import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WeekendHomeCard() {
  const [next, setNext] = useState(null);

  useEffect(() => {
    axios.get(`${API}/departures`)
      .then((r) => setNext(r.data.find((d) => !d.closed) || null))
      .catch(() => setNext(null));
  }, []);

  if (!next) return null;

  return (
    <section className="section-padding" style={{ background: 'var(--bg-secondary)', borderBottom: '1px solid var(--border-light)' }} data-testid="home-weekend-card-section">
      <div className="container">
        <div data-testid="home-weekend-card" style={{ border: '1px solid var(--border-medium)', background: 'var(--bg-primary)', padding: '40px', display: 'flex', flexWrap: 'wrap', gap: '32px', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ flex: '1 1 420px' }}>
            <p className="body-small" style={{ color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: '0.14em', marginBottom: '12px' }}>2-Day Delhi + Agra Weekend</p>
            <h2 className="heading-1" style={{ marginBottom: '12px' }}>Delhi and the Taj Mahal in one weekend. Every ticket included.</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }} data-testid="home-weekend-next-date">
              Next departure: {next.saturday_label} – {next.sunday_label}
            </p>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <p className="heading-1" style={{ margin: 0 }} data-testid="home-weekend-price">
              ₹7,499 <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>per person</span>
            </p>
            <Link to="/weekend-tour" className="btn-primary" data-testid="home-weekend-card-btn">
              View the Weekend Tour<ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
